export const ALERT_TYPES = {
  INFO: "info",
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning"
};

export const ALERT_MESSAGES = {
  NO_FILE: "No File To Upload",
  UPLOAD_SUCCESS: (msg = "") => `Successfully Uploaded File! \n\n ${msg}`,
};

export const DEFAULT_ALERT_STATE = {
  alertOpen: false,
  alertType: ALERT_TYPES.INFO,
  alertMsg: "",
};